import React from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import FullScreenLoader from "../components/FullScreenLoader";
import { useLoading } from "../context/LoadingContext"; // ✅ Import Global Loading

const MainLayout = ({ children }) => {
  const { loading } = useLoading(); // ✅ Use Global Loading

  return (
    <div className="main-layout">
      {/* Header */}
      <Header />

      {/* Loading Screen */}
      <FullScreenLoader loading={loading} />

      {/* Main Content Area */}
      <div className="main">
        {/* Sidebar */}
        <Sidebar />
        <div className="right_part">
          {/* Page-specific content */}
          {children}
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
